import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Row, Card, Select, Modal, message } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import { LocalPersistence } from '../../../factories';
import { deleteLoyalty, updateLoyalty } from '../../../services/affiliations';
import PageContainer from '../../CSIComponents/PageContainer';
import DetailItem from '../../CSIComponents/DetailItem';
import ReadOnlyTextArea from '../../CSIComponents/ReadOnlyTextarea';
import Loading from '../../Loading';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import styles from '../styles.module.css';

const { Option } = Select;

const EditAward = (props: any) => {
  const travelSectorOptions = ['Air', 'Car', 'Hotel', 'Insurance', 'Golf', 'Tour', 'Rail', 'Cruise', 'Excursion', 'Ferry', 'Package Option'];

  const [detailData, setDetailData] = useState(
    [
      { label: 'Program Name', value: props.rowData.programname, span: 6 },
      { label: 'Secondary Name', value: props.rowData.secondaryname, span: 6 },
      { label: 'Travel Sector', value: props.rowData.travelsector, span: 6 },
      { span: 6 },
      { label: 'Primary Program', value: props.rowData.primaryprogram, span: 6 },
      { span: 12 },
      { label: 'Restriction', value: props.rowData.restriction, span: 18, type:'textArea' },
      { label: 'Description', value: props.rowData.description, span: 18, type:'textArea' },
      { span: 12 }
    ]
  )
  const [detailRowData, setDetailRowData] = useState(props.rowData);
  const [editFlag, setEditFlag] = useState(false);
  const [addLoading, setAddLoading] = useState(false)
  const [disabledStatus, setDisabledStatus] = useState(true)
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    const params = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "affiliations": {
          "loyaltyprograms": [
            {
              loyaltyprogramid: props.rowData.loyaltyprogramid,
              loyaltyprogramlangid: props.rowData.loyaltyprogramlangid,
            }
          ]
        }
      }
    }

    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${detailRowData.programname} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async () => {
        const res = await deleteLoyalty(params);
        if (res.result.success) {
          form.resetFields();
          props.cancelAddAndEdit();
        }
      },
      onCancel() {

      },
    });

  }
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "affiliations": {
            "loyaltyprograms": [
              {
                ...value,
                loyaltyprogramid: props.rowData.loyaltyprogramid,
                loyaltyprogramlangid: props.rowData.loyaltyprogramlangid,
              }
            ]
          }
        }
      }
      setAddLoading(true)
      updateLoyalty(params).then(res => {
        setAddLoading(false)
        if (res.result.success) {
          form.resetFields();
          setDetailRowData({ ...value })
          setEditFlag(false);
          props.cancelEditable();
          props.disableTabPanes(false);
        } else {
          message.error({
            content: res?.error[0]?.message || 'operation failed'
          });
        }
      }, err => {
        message.error({
          content: err.message || err.error[0].message
        });
        setAddLoading(false)
      });

    })
  }
  const editHandle = () => {
    setEditFlag(true);
    const initialValues = {
      programname: detailRowData.programname,
      secondaryname: detailRowData.secondaryname,
      primaryprogram: detailRowData.primaryprogram,
      restriction: detailRowData.restriction,
      travelsector: detailRowData.travelsector,
      description: detailRowData.description
    }
    form.setFieldsValue(initialValues);
  }
  useEffect(() => {
    setDetailData([
      { label: 'Program Name', value: detailRowData.programname, span: 6 },
      { label: 'Secondary Name', value: detailRowData.secondaryname, span: 6 },
      { label: 'Travel Sector', value: detailRowData.travelsector, span: 6 },
      { span: 6 },
      { label: 'Primary Program', value: detailRowData.primaryprogram, span: 6 },
      { span: 12 },
      { label: 'Restriction', value: detailRowData.restriction, span: 18, type:'textArea' },
      { label: 'Description', value: detailRowData.description, span: 18, type:'textArea' },
      { span: 12 }
    ])
  }, [detailRowData])
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled)
      return;
    }
    form.validateFields().then(() => {
      setDisabledStatus(false)

    }).catch(() => {
      const errTotalNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;

      if (errTotalNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }

    })
  }
  useEffect(() => {
    validateFieldsError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (addLoading) return <Loading type="large" />
  return !editFlag ? (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button
                  type='primary'
                  className='db-edit-btn'
                  onClick={() => {
                    props.cancelAddAndEdit()
                    form.resetFields()
                  }}>
                  Back
                </Button>
              </div>
              <div>
                <Button
                  type='primary'
                  className='db-edit-btn'
                  onClick={() => {
                    editHandle()
                    props.isEditable()
                    props.disableTabPanes(true)
                  }}>
                  Edit
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className='p-0'>
            <div
              className={styles.titleStyles}
              style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
              {detailRowData.programname}
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Row gutter={24}>
              {detailData.map((item: any, i) => {
                return item.label ? (
                  <Col span={item.span} key={i} className='col-margin'>
                    {item.type !== 'textArea' ? (
                      <DetailItem value={item.value} label={item.label} />
                    ) : (
                      <ReadOnlyTextArea value={item.value} label={item.label} />
                    )}
                  </Col>
                ) : (
                  <Col span={item.span} key={i}></Col>
                )
              })}
            </Row>
          </Grid>
        </Grid>
      </Card>
    </PageContainer>
  ) : (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                {props.rowData.programname}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onValuesChange={(changedFields, allFields) => {
                validateFieldsError()
              }}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label='Program Name'
                    name='programname'
                    rules={[
                      {
                        max: 128,
                        message:
                          'You have reached the max character length of 128',
                      },
                    ]}>
                    <Input maxLength={128} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label='Secondary Name'
                    name='secondaryname'
                    rules={[
                      {
                        max: 65,
                        message:
                          'You have reached the max character length of 65',
                      },
                    ]}>
                    <Input maxLength={65} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Travel Sector' name='travelsector'>
                    <Select allowClear showSearch>
                      {travelSectorOptions.map((item, index) => (
                        <Option value={item} key={index}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}></Col>
                <Col span={6}>
                  <Form.Item label='Primary Program' name='primaryprogram'>
                    <Select allowClear showSearch>
                      <Option value={'Yes'}>Yes</Option>
                      <Option value={'No'}>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={18}>
                  <Form.Item
                    label='Restriction'
                    name='restriction'
                    rules={[
                      {
                        max: 200,
                        message:
                          'You have reached the max character length of 200',
                      },
                    ]}>
                    <TextArea maxLength={200} />
                  </Form.Item>
                </Col>
                <Col span={18}>
                  <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                      {
                        max: 4000,
                        message:
                          'You have reached the max character length of 4000',
                      },
                    ]}>
                    <TextArea maxLength={4000} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onDelete={DeleteClick}
        onCancel={() => {
          props.cancelEditable()
          props.disableTabPanes(false)
          setEditFlag(false)
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disabledStatus}
      />
    </PageContainer>
  )
}
export default EditAward;
